module.exports = __webpack_public_path__ + "static/media/app-argento-lab.406b175d.jpg";